<template>
  <div>
    <div class="card card-custom gutter-b" style="box-shadow: none">
      <div class="card-header card-header-tabs-line">
        <ul
          class="nav nav-dark nav-bold nav-tabs nav-tabs-line"
          role="tablist"
          ref="builder-tab"
        >
          <li class="nav-item">
            <a
              class="nav-link active"
              data-tab="0"
              data-toggle="tab"
              href="#"
              role="tab"
            >
              Cadastro
            </a>
          </li>
        </ul>
      </div>

      <b-form class="form" @submit.stop.prevent="onSubmit">
        <div class="card-body">
          <b-tabs class="hide-tabs" v-model="tabIndex">
            <b-tab active>
              <b-row>
                <b-col md="6">
                  <b-col>
                    <b-form-group id="nome" label-for="nome" label="Nome">
                      <b-form-input
                        v-model="$v.form.nome.$model"
                        :state="validateState('nome')"
                        autofocus
                        placeholder="Nome do terminal"
                      />
                    </b-form-group>
                  </b-col>
                </b-col>
                <b-col md="6">
                  <b-col>
                    <b-form-group
                      id="uuid_terminal"
                      label-for="uuid_terminal"
                      label="UUID do Terminal"
                    >
                      <b-form-input
                        v-model="form.uuid_terminal"
                        placeholder="UUID gerado automaticamente pelo sistema"
                        :disabled="isUpdate"
                      />
                    </b-form-group>
                  </b-col>
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
        </div>

        <div class="card-footer">
          <div class="row">
            <div class="col-lg-12" style="text-align: center">
              <button
                type="submit"
                ref="submit_terminal"
                class="btn btn-primary font-weight-bold"
              >
                Salvar
              </button>
              <router-link
                class="btn btn-clean font-weight-bold"
                :to="{ name: 'terminais' }"
              >
                Cancelar
              </router-link>
            </div>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { SistemaMixin } from "@/modules/Application";
import TerminalData, { TerminalDataRequired } from "./TerminalData";
import { mapGetters } from "vuex";

export default {
  name: "app-terminal-form",
  props: {
    url: {
      type: String,
    },
    terminal: {
      type: Object,
      default: () => {},
    },
    isUpdate: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [validationMixin, SistemaMixin],
  data() {
    return {
      tabIndex: 0,
      form: new TerminalData({}),
    };
  },
  validations: {
    form: TerminalDataRequired,
  },
  watch: {
    terminal(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.form = newValue;
      }
    },
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    async onSubmit() {
      const submitButton = this.$refs["submit_terminal"];

      try {
        this.$v.form.$touch();

        if (this.$v.form.$anyError) {
          this.$toast.error(
            "Verifique todos os campos obrigatórios do formulário!"
          );
          return;
        }

        submitButton.classList.add("spinner", "spinner-light", "spinner-right");
        submitButton.setAttribute("disabled", "");

        await this.$http.post(this.url, this.form);
        this.$router.push({ name: "terminais" });
      } catch {
        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
        submitButton.removeAttribute("disabled", "");
      }
    },
  },
};
</script>
